// extracted by mini-css-extract-plugin
module.exports = {"portaledChipContainer":"BookAnalyticsWrapper-module__portaledChipContainer--1XKF0","takeUpSpace":"BookAnalyticsWrapper-module__takeUpSpace--N6HFX"};